import React from 'react';
import {
    BrowserRouter as Router,
    Route,
    Routes as Switch,
} from 'react-router-dom';
import ListEmpty from '../components/fragments/ListEmpty';
import ChangePasswordScreen from '../screens/auth/ChangePasswordScreen';
import OnboarderScreen from '../screens/auth/OnboarderScreen';
import RegisterScreen from '../screens/auth/RegisterScreen';
import ResetPasswordScreen from '../screens/auth/ResetPasswordScreen';
import Books from '../screens/bible/Books';
import Chapters from '../screens/bible/Chapters';
import MyBibleScreen from '../screens/bible/MyBibleScreen';
import NotepadAddScreen from '../screens/bible/NotepadAddScreen';
import NotepadRouteScreen from '../screens/bible/NotepadRouteScreen';
import NotepadScreen from '../screens/bible/NotepadScreen';
import StudyReminderAddScreen from '../screens/bible/StudyReminderAddScreen';
import StudyReminderScreen from '../screens/bible/StudyReminderScreen';
import Verses from '../screens/bible/Verses';
import DebugScreen from '../screens/dev/DebugScreen';
import CreatePostScreen from '../screens/feed/CreatePostScreen';
import FeedRouteScreen from '../screens/feed/FeedRouteScreen';
import ReportScreen from '../screens/feed/ReportScreen';
import ChatRouteScreen from '../screens/guest/ChatRouteScreen';
import ChatScreen from '../screens/guest/ChatScreen';
import ChurchFinderTab from '../screens/guest/ChurchFinderTab';
import ChurchListScreen from '../screens/guest/ChurchListScreen';
import ChurchViewScreen from '../screens/guest/ChurchViewScreen';
import ScreenCreateCrusade from '../screens/guest/create/ScreenCreateCrusade';
import ScreenCreateDevotion from '../screens/guest/create/ScreenCreateDevotion';
import ScreenCreatePost from '../screens/guest/create/ScreenCreatePost';
import ScreenCreateService from '../screens/guest/create/ScreenCreateService';
import CrusadeRouteScreen from '../screens/guest/CrusadeRouteScreen';
import CrusadeScreen from '../screens/guest/CrusadeScreen';
import GuestFeedRouteScreen from '../screens/guest/GuestFeedRouteScreen';
import GuestFeedScreen from '../screens/guest/GuestFeedScreen';
import GuestNotificationsScreen from '../screens/guest/GuestNotificationsScreen';
import GuestProfileScreen from '../screens/guest/GuestProfileScreen';
import GuestSettingsScreen from '../screens/guest/GuestSettingsScreen';
import MinisterSignupPage from '../screens/guest/MinisterSignupPage';
import MyPastors from '../screens/guest/MyPastors';
import MyWallet from '../screens/guest/MyWallet';
import ScreenChurchMapList from '../screens/guest/ScreenChurchMapList';
import ScreenDonate from '../screens/guest/ScreenDonate';
import ScreenGuestProfileUpdate from '../screens/guest/ScreenGuestProfileUpdate';
import ScreenMinisterView from '../screens/guest/ScreenMinisterView';
import ScreenMyInformation from '../screens/guest/ScreenMyInformation';
import ScreenStartChat from '../screens/guest/ScreenStartChat';
import AppointmentRouteScreen from '../screens/home/AppointmentRouteScreen';
import AppointmentsScreen from '../screens/home/AppointmentsScreen';
import BookingScreen from '../screens/home/BookingScreen';
import ContributionMpesaScreen from '../screens/home/ContributionMpesaScreen';
import ContributionScreen from '../screens/home/ContributionScreen';
import DevotionRouteScreen from '../screens/home/DevotionRouteScreen';
import DevotionsScreen from '../screens/home/DevotionsScreen';
import EventMapScreen from '../screens/home/EventMapScreen';
import EventScreen from '../screens/home/EventScreen';
import LiveStreamScreen from '../screens/home/LiveStreamScreen';
import MessageChurchScreen from '../screens/home/MessageChurchScreen';
import MinistriesScreen from '../screens/home/MinistriesScreen';
import MinistryRouteScreen from '../screens/home/MinistryRouteScreen';
import NotificationScreen from '../screens/home/NotificationScreen';
import ServiceRouteScreen from '../screens/home/ServiceRouteScreen';
import ServiceScreen from '../screens/home/ServiceScreen';
import ChangeAvatarScreen from '../screens/profile/ChangeAvatarScreen';
import ChildrenAddScreen from '../screens/profile/ChildrenAddScreen';
import ChildrenUpdateScreen from '../screens/profile/ChildrenUpdateScreen';
import ContributionStatementScreen from '../screens/profile/ContributionStatementScreen';
import HelpScreen from '../screens/profile/HelpScreen';
import Logout from '../screens/profile/Logout';
import MyChildrenScreen from '../screens/profile/MyChildrenScreen';
import NotificationSettingsScreen from '../screens/profile/NotificationSettingsScreen';
import ScanQRCameraScreen from '../screens/profile/ScanQRCameraScreen';
import ScanQRScreen from '../screens/profile/ScanQRScreen';
import SettingsScreen from '../screens/profile/SettingsScreen';
import UpdateProfileScreen from '../screens/profile/UpdateProfileScreen';
import AboutKanisa from '../screens/static/AboutKanisa';
import PrivacyScreen from '../screens/static/PrivacyScreen';
import Promise from '../screens/static/Promise';
import Terms from '../screens/static/Terms';
import DiscoverTab from '../tabs/DiscoverTab';
import FeedTab from '../tabs/FeedTab';
import HomeTab from '../tabs/HomeTab';
import ProfileTab from '../tabs/ProfileTab';
import MyFamilyScreen from '../screens/profile/MyFamilyScreem';
import MySpouseScreen from '../screens/profile/MySpouseScreen';

export default function Routes() {
    return (
        <Router>
            <Switch>
                {/* Tabs */}
                <Route path="/" element={<HomeTab />} />
                <Route path="/profile" element={<ProfileTab />} />
                <Route path="/feed" element={<FeedTab />} />
                <Route path="/discover" element={<DiscoverTab />} />

                {/* External tabs */}
                <Route path="/guest-feed" element={<GuestFeedScreen />} />
                <Route path="/crusade" element={<CrusadeScreen />} />
                <Route path="/find" element={<ChurchFinderTab />} />
                <Route path="/guest-profile" element={<GuestProfileScreen />} />

                {/* Screens */}
                <Route path="/help" element={<HelpScreen />} />
                <Route path="/churches" element={<ChurchListScreen />} />
                <Route path="/map-churches" element={<ScreenChurchMapList />} />
                <Route path="/events" element={<EventScreen />} />
                <Route path="/event-map" element={<EventMapScreen />} />
                <Route path="/services" element={<ServiceScreen />} />
                <Route path="/create-post" element={<CreatePostScreen />} />
                <Route path="/bookings" element={<BookingScreen />} />
                <Route path="/chat-start" element={<ScreenStartChat />} />
                <Route path="/appointments" element={<AppointmentsScreen />} />
                <Route path="/livestream" element={<LiveStreamScreen />} />
                <Route path="/msg" element={<MessageChurchScreen />} />
                <Route path="/notifications" element={<NotificationScreen />} />
                <Route path="/settings" element={<SettingsScreen />} />
                <Route path="/wallet" element={<MyWallet />} />
                <Route path="/bible" element={<MyBibleScreen />} />
                <Route path="/devotions" element={<DevotionsScreen />} />
                <Route path="/ministries" element={<MinistriesScreen />} />
                <Route path="/contribution" element={<ContributionScreen />} />
                <Route
                    path="/notification-settings"
                    element={<NotificationSettingsScreen />}
                />
                <Route
                    path="/guest-settings"
                    element={<GuestSettingsScreen />}
                />
                <Route
                    path="/guest-notifications"
                    element={<GuestNotificationsScreen />}
                />
                <Route
                    path="/bible-tools/notepad"
                    element={<NotepadScreen />}
                />
                <Route
                    path="/bible-tools/notepad-add"
                    element={<NotepadAddScreen />}
                />
                <Route
                    path="/bible-tools/study-reminder"
                    element={<StudyReminderScreen />}
                />
                <Route
                    path="/bible-tools/study-reminder-add"
                    element={<StudyReminderAddScreen />}
                />
                <Route
                    path="/minister-signup"
                    element={<MinisterSignupPage />}
                />
                <Route
                    path="/contribution/mpesa"
                    element={<ContributionMpesaScreen />}
                />
                <Route
                    path="/contribution-statement"
                    element={<ContributionStatementScreen />}
                />

                {/*  */}
                <Route path="/scan-qr" element={<ScanQRScreen />} />
                <Route path="/pastors" element={<MyPastors />} />
                <Route path="/chat" element={<ChatScreen />} />
                <Route path="/children" element={<MyChildrenScreen />} />
                <Route path="/family" element={<MyFamilyScreen />} />
                <Route path="/spouse" element={<MySpouseScreen />} />
                <Route path="/add/children" element={<ChildrenAddScreen />} />
                <Route path="/change-avatar" element={<ChangeAvatarScreen />} />
                <Route path="/donate" element={<ScreenDonate />} />
                <Route
                    path="/change-password"
                    element={<ChangePasswordScreen />}
                />
                <Route
                    path="/update-profile"
                    element={<UpdateProfileScreen />}
                />
                <Route
                    path="/guest-update-profile"
                    element={<ScreenGuestProfileUpdate />}
                />
                <Route path="/information" element={<ScreenMyInformation />} />
                <Route path="/om/service" element={<ScreenCreateService />} />
                <Route path="/om/devotion" element={<ScreenCreateDevotion />} />
                <Route path="/om/post" element={<ScreenCreatePost />} />
                <Route path="/om/crusade" element={<ScreenCreateCrusade />} />

                {/*  */}
                <Route path="/about" element={<AboutKanisa />} />
                <Route path="/privacy" element={<PrivacyScreen />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/promise" element={<Promise />} />
                <Route path="/logout" element={<Logout />} />
                <Route path="/debug" element={<DebugScreen />} />

                {/* Sub Routes */}
                <Route path="/chat/:id" element={<ChatRouteScreen />} />
                <Route path="/crusade/:id" element={<CrusadeRouteScreen />} />
                <Route path="/scan-qr/:id" element={<ScanQRCameraScreen />} />
                <Route path="/service/:id" element={<ServiceRouteScreen />} />
                <Route path="/church/:id" element={<ChurchViewScreen />} />
                <Route path="/minister/:id" element={<ScreenMinisterView />} />
                <Route path="/devotion/:id" element={<DevotionRouteScreen />} />
                <Route path="/ministry/:id" element={<MinistryRouteScreen />} />
                <Route path="/feed/:id" element={<FeedRouteScreen />} />
                <Route path="/report/:id" element={<ReportScreen />} />
                <Route path="/bible/:version" element={<Books />} />
                <Route path="/bible/:version/:book" element={<Chapters />} />
                <Route
                    path="/guest-feed/:id"
                    element={<GuestFeedRouteScreen />}
                />
                <Route
                    path="/children/:id"
                    element={<ChildrenUpdateScreen />}
                />
                <Route
                    path="/appointment/:id"
                    element={<AppointmentRouteScreen />}
                />
                <Route
                    path="/bible/:version/:book/:chapter"
                    element={<Verses />}
                />
                <Route
                    path="/bible-tools/notepad/:id"
                    element={<NotepadRouteScreen />}
                />

                {/* App Flow and Auth */}
                <Route path="/register" element={<RegisterScreen />} />
                <Route path="/onboarder" element={<OnboarderScreen />} />
                <Route
                    path="/reset-password"
                    element={<ResetPasswordScreen />}
                />

                {/* Not Found */}
                <Route
                    path="/*"
                    element={<ListEmpty title="404 | Not Found" />}
                />
            </Switch>
        </Router>
    );
}

// TODO: remove and delete AuthTabs
